var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.absoluteStyle,style:({
  width: ((_vm.width + _vm.dw) + "px"),
  height: ((Math.round((_vm.width + _vm.dw) / _vm.ratio)) + "px"),
  transform: ("translate(" + (_vm.x + _vm.dx) + "px, " + (_vm.y + _vm.dy) + "px)"),
})},[_c('div',{class:[
    _vm.$style.imgMoveContainer,
    _vm.operation === 'move' ? _vm.$style.cursorGrabbing : '',
    _vm.operation ? _vm.$style.operation : '' ],on:{"mousedown":_vm.handlePanStart,"touchstart":_vm.handlePanStart}},[(!_vm.fixSize)?_c('div',{class:[
      _vm.$style.absoluteStyle,
      _vm.$style.selector,
      _vm.$style.cursorResize ],style:({ top: '0%', left: '0%' }),attrs:{"data-direction":"left-top"}}):_vm._e(),(!_vm.fixSize)?_c('div',{class:[
      _vm.$style.absoluteStyle,
      _vm.$style.selector,
      _vm.$style.cursorResize ],style:({ top: '0%', left: '100%' }),attrs:{"data-direction":"right-top"}}):_vm._e(),(!_vm.fixSize)?_c('div',{class:[
      _vm.$style.absoluteStyle,
      _vm.$style.selector,
      _vm.$style.cursorResize ],style:({ top: '100%', left: '0%' }),attrs:{"data-direction":"left-bottom"}}):_vm._e(),(!_vm.fixSize)?_c('div',{class:[
      _vm.$style.absoluteStyle,
      _vm.$style.selector,
      _vm.$style.cursorResize ],style:({ top: '100%', left: '100%' }),attrs:{"data-direction":"right-bottom"}}):_vm._e()]),(!_vm.fixSize)?_c('div',{class:[
    _vm.$style.absoluteStyle,
    _vm.$style.cursorGrabbing,
    _vm.$style.delete
  ],style:({ top: '0%', left: '50%' }),on:{"click":_vm.onDelete}},[_c('img',{attrs:{"src":require("./assets/close.png"),"alt":"delete object"}})]):_vm._e(),_c('canvas',{ref:"imgCanvas",class:_vm.$style.imgCanvasView})])}
var staticRenderFns = []

export { render, staticRenderFns }